/**
 * @module api/publicApi/publicPaymentDomainApi
 */

import secureClient from 'lib/secure-client';
import mitraPaymentDomainApiUrl from 'shared_js/helpers/urlHelper/mitraPaymentDomainApiUrl';

/**
 * Retrieve active payment method from payment domain
 *
 */
function retrieveActivePaymentMethod() {
  return this.get(
    `${mitraPaymentDomainApiUrl}/v1/payment/payment-channels`,
    'user',
    { enableAuthHeader: true },
  );
}

/**
 * Retrieve user's account info
 */
function retrieveUserAccountInfo() {
  return this.get(`${mitraPaymentDomainApiUrl}/v1/payment/accounts`, 'user', {
    enableAuthHeader: true,
  });
}

/**
 * Generate B2B2C access token for wallet VJI (BukaPay).
 */
function generateWalletVjiB2b2cToken() {
  return this.post(
    `${mitraPaymentDomainApiUrl}/v1/payment/wallet-vji/b2b2c-token`,
    'user',
    {
      enableAuthHeader: true,
      data: {},
    },
  );
}

/**
 * Retrieve user's withdrawal bank accounts
 */
function retrieveUserWithdrawalBankAccounts(params = {}) {
  return this.get(
    `${mitraPaymentDomainApiUrl}/v1/payment/withdrawals/bank-accounts`,
    'user',
    {
      enableAuthHeader: true,
      params,
    },
  );
}

/**
 * Collection of api
 */
const publicPaymentDomainApi = secureClient(
  {
    retrieveActivePaymentMethod,
    retrieveUserAccountInfo,
    generateWalletVjiB2b2cToken,
    retrieveUserWithdrawalBankAccounts,
  },
  'xhrPublicPaymentDomainApi',
);

export default publicPaymentDomainApi;
